import React, { Component } from "react";
import {
  Steps,
  Icon,
  Spin,
  Dropdown,
  Menu,
  message,
  Divider,
  List,
  Button,
  Modal
} from "antd";
import { parse, stringify } from "qs";
import moment from "moment";
import Card from "nbugs-mobile-card";
import { connect } from "dva";
import router from "umi/router";
import Container from "../../../../../components/Container";
import setTarget from "../../assets/set-target.svg";
import toolManage from "../../assets/tool-manage.svg";
import Esetting from "../../assets/e-setting.svg";
import Psetting from "../../assets/p-setting.svg";
import standard from "../../assets/standard.svg";
import setMember from "../../assets/set-member.svg";
import evaluateReport from "../../assets/pinggubaogao_icon_n.svg";
import CriterionModalView from "../components/CriterionModal";
import styles from "./index.less";
import { url } from "../../services/service-utils";

const { Step } = Steps;
const { Item } = Menu;
const { confirm } = Modal;
const stepMap = {
  10: 0,
  20: 0,
  30: 1,
  40: 1,
  50: 2,
  60: 3
};
const statusNameMap = {
  "1": "未开始",
  "2": "进行中",
  "3": "已结束"
};

@connect(({ projectDetail, tree }) => ({
  projectInfo: projectDetail.projectInfo,
  spinProps: projectDetail.spinProps,
  templateList: projectDetail.templateList
}))
class Overview extends Component {
  constructor(props) {
    super(props);

    const { search } = window.location; // 换车utils里的GetQueryString
    const query = parse(search.split("?").pop());
    const { currentProjectId } = query;

    this.state = {
      currentProjectId,
      showCriterionModal: false
    };
  }

  componentDidMount() {
    this.getDetail();
    this.getModalList();
    this.handleInitCriterionTab();
  }

  // 重置评估标准页面的tab
  handleInitCriterionTab = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "projectCriterion/save",
      payload: {
        nowActiveTabKey: "1"
      }
    });
  };

  // componentWillUnmount() {
  //   const { dispatch } = this.props;
  //   dispatch({
  //     type: "tree/reset"
  //   });
  //   dispatch({
  //     type:'projectDetail/reset'
  //   })
  // }

  getModalList = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchModalList",
      payload: {
        projectId: currentProjectId
      }
    });
  };

  getDetail = () => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchProjectInfo",
      payload: {
        projectId: currentProjectId
      }
    });
  };

  handleJump = url => {
    router.push(`${url}${window.location.search}`);
  };

  handleChangeStatus = status => {
    const { currentProjectId } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "projectDetail/fetchUploadStatus",
      payload: {
        projectId: currentProjectId,
        status
      },
      callback: this.getDetail
    });
  };

  // 设置评估标准模板
  handleSetEvaluateTemplate = (templateId, isActive) => {
    const { dispatch } = this.props;
    const { currentProjectId } = this.state;
    if (isActive === "true") {
      confirm({
        content:
          "检测到该模板存在当前项目中所包含学校的个 性化指标配置，是否进行匹配？",
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          dispatch({
            type: "projectDetail/fetchSetEvaluateTemplate",
            payload: {
              templateId,
              projectId: currentProjectId,
              enableOrg: true
            },
            callback: this.handleJumpTree
          });
        },
        onCancel: () => {
          dispatch({
            type: "projectDetail/fetchSetEvaluateTemplate",
            payload: {
              templateId,
              projectId: currentProjectId,
              enableOrg: false
            },
            callback: this.handleJumpTree
          });
        }
      });
    } else {
      dispatch({
        type: "projectDetail/fetchSetEvaluateTemplate",
        payload: {
          templateId,
          projectId: currentProjectId,
          enableOrg: false
        },
        callback: this.handleJumpTree
      });
    }
  };

  // 选择指标模板确定后跳转到树页面
  handleJumpTree = () => {
    const { currentProjectId } = this.state;
    router.push(
      `/supervision/norm/project/overview/criterion?${stringify({
        currentProjectId
      })}`
    );
  };

  handleShowCriterionModal = (current, selectTemplate) => {
    if (selectTemplate) {
      this.handleJumpTree();
    } else {
      this.setState({
        showCriterionModal: true
      });
    }
  };

  handleEvaluate = processStatus => {
    if (processStatus === 50) {
      this.handleJump("/supervision/norm/project/overview/myEvaluation");
    } else {
      message.error("不在评估时间");
    }
  };

  // 跳转编辑页面
  handleGoToEdit = () => {
    this.handleJump("/supervision/norm/project/overview/edit");
  };

  // 下载发布评估报告
  handleDownloadReport = processStatus => {
    const { currentProjectId } = this.state;
    if (processStatus === 60) {
      window.location.href = `${url.url}/project/statistics/word/download?projectId=${currentProjectId}`;
    } else {
      message.error("不在发布评估报告时间内");
    }
  };

  // 渲染项目基础设置
  renderSettingList = () => {
    return (
      <>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/project/overview/member")
          }
        >
          <img src={setMember} alt="" />
          <div>项目成员信息</div>
        </div>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/project/overview/target")
          }
        >
          <img src={setTarget} alt="" />
          <div>项目督查对象</div>
        </div>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/project/overview/setting")
          }
        >
          <img src={Psetting} alt="" />
          <div>项目设置</div>
        </div>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/project/overview/evaluate")
          }
        >
          <img src={Esetting} alt="" />
          <div>评估设置</div>
        </div>
      </>
    );
  };

  // 渲染项目应用工具
  renderToolList = ({ current, selectTemplate, processStatus }) => {
    return (
      <>
        <div
          className="tool-item"
          onClick={() => this.handleShowCriterionModal(current, selectTemplate)}
        >
          <img src={standard} alt="" />
          <div>评估标准</div>
        </div>
        <div
          className="tool-item"
          onClick={() => this.handleEvaluate(processStatus)}
        >
          <img src={toolManage} alt="" />
          <div>评估管理</div>
        </div>
        <div
          className="tool-item"
          onClick={() =>
            this.handleJump("/supervision/norm/project/overview/statistics")
          }
        >
          <img src={Psetting} alt="" />
          <div>项目统计</div>
        </div>
        <div
          className="tool-item"
          onClick={() => this.handleDownloadReport(processStatus)}
        >
          <img src={evaluateReport} alt="" />
          <div>发布评估报告</div>
        </div>
      </>
    );
  };

  // 渲染底部按钮
  renderFooterBtn = allowEdit => {
    const footerParams = {
      states: allowEdit, // 是否展示底部按钮区域，默认为false 不展示
      demFooter: (
        <>
          <Button type="primary" onClick={this.handleGoToEdit}>
            编辑
          </Button>
        </>
      )
    };
    return footerParams;
  };

  render() {
    const { showCriterionModal } = this.state;
    const { projectInfo, spinProps, templateList } = this.props;
    const {
      principalList,
      status,
      processStatus,
      projectName,
      introduction,
      selectTemplate,
      startTime,
      endTime,
      allowEdit
    } = projectInfo;
    const current = stepMap[processStatus];
    const mean = (
      <Menu>
        <Item>
          <span onClick={() => this.handleChangeStatus(1)}>未开始</span>
        </Item>
        <Item>
          <span onClick={() => this.handleChangeStatus(2)}>进行中</span>
        </Item>
        <Item>
          <span onClick={() => this.handleChangeStatus(3)}>已结束</span>
        </Item>
      </Menu>
    );

    const containerProps = {
      breStates: true,
      version: 2,
      footerParams: this.renderFooterBtn(allowEdit),
      defaultPadding: true,
      isSplitBar: true
    };

    return (
      <Container {...containerProps}>
        <div className={styles.overview}>
          <Spin {...spinProps}>
            <div className="first_part">
              <div className="title">
                <div className="left">
                  <span className="verticalBar" />
                  <span>
                    {projectName}
                    <Dropdown
                      trigger={["click"]}
                      overlay={mean}
                      placement="bottomCenter"
                    >
                      <Button
                        className={
                          status === "2" ? "startedProject" : "otherProject"
                        }
                      >
                        {statusNameMap[status]}
                        <Icon type="down" />
                      </Button>
                    </Dropdown>
                  </span>
                </div>
              </div>
              <Divider />
              <div className="projectNews">
                <List.Item>
                  <span className="itemName">负责人</span>:
                  <span style={{ marginLeft: 16 }}>
                    {principalList &&
                      principalList.map((item, index) => {
                        return index === principalList.length - 1
                          ? item.userName
                          : `${item.userName}、`;
                      })}
                  </span>
                </List.Item>
                <List.Item>
                  <span className="itemName">项目计划时间</span>:
                  <span style={{ marginLeft: 16 }}>
                    {startTime && moment(startTime).format("YYYY.MM.DD")} ~{" "}
                    {endTime && moment(endTime).format("YYYY.MM.DD")}
                  </span>
                </List.Item>
              </div>
            </div>
            <div className="second_part">
              <Divider orientation="left">项目介绍</Divider>
              <div>
                {introduction && (
                  <Card
                    maxHeight={160}
                    wrapShowMode="normal"
                    key={introduction}
                  >
                    <div dangerouslySetInnerHTML={{ __html: introduction }} />
                  </Card>
                )}
              </div>
              <div className="tool-wrap-set">
                <Divider orientation="left">项目基础设置</Divider>
                <div className="tool-content">{this.renderSettingList()}</div>
              </div>
              <div className="tool-wrap-apply">
                <Divider orientation="left">项目应用工具</Divider>
                <div className="tool-content">
                  {this.renderToolList({
                    current,
                    selectTemplate,
                    processStatus
                  })}
                </div>
              </div>
              <div className="step-wrap">
                <Divider orientation="left">项目工作流程</Divider>
                <div className="step-content">
                  <Steps
                    className="step-process"
                    progressDot
                    size="small"
                    current={selectTemplate ? current : 0}
                  >
                    <Step
                      title={!selectTemplate ? "请设置评估标准" : "评估标准"}
                      onClick={() =>
                        this.handleShowCriterionModal(current, selectTemplate)
                      }
                    />
                    <Step
                      title={
                        processStatus === 30 ? "正在自查自评中" : "自查自评"
                      }
                    />
                    <Step
                      title={processStatus === 50 ? "正在评估中" : "评估"}
                      onClick={() => this.handleEvaluate(processStatus)}
                    />
                    <Step
                      title="发布评估报告"
                      onClick={() => this.handleDownloadReport(processStatus)}
                    />
                  </Steps>
                </div>
              </div>
            </div>
            {showCriterionModal && (
              <CriterionModalView
                onCancel={() => this.setState({ showCriterionModal: false })}
                templateList={templateList}
                handleSetEvaluateTemplate={(templateId, isActive) =>
                  this.handleSetEvaluateTemplate(templateId, isActive)
                }
              />
            )}
          </Spin>
        </div>
      </Container>
    );
  }
}

export default Overview;
